import {Box, CircularProgress, Grid, Typography} from "@material-ui/core";
import Brand from "./components/brand";
import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import {GiftCardCategoryApi} from "../../../services/api/giftCard";

const GiftCardView = () => {
    const history = useHistory();
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(true);

    const api = async () => {
        setLoading(true)
        const res = await GiftCardCategoryApi();
        res&& setLoading(false);
        setBrands(res?.data);
    }

    const showGiftCardHandler = (groupid : any) => {
        history.push(`/gift-card/${groupid}`);
    };

    useEffect(() => {
        api();
    }, []);
    
    return(
        <>
            {/* @ts-ignore */}
            <Box className="dir p-res Box mainBox customBox">
                <Grid container>
                    <Grid item xs={12}>
                        {/* @ts-ignore */}
                        <Grid container className="mt-3" spacing={1}>
                            {loading ? (
                                <>
                                    {/* @ts-ignore */}
                                    <Box sx={{ margin: "0px auto" }}>
                                        <div style={{ textAlign: "center" }}>
                                            <CircularProgress />
                                        </div>
                                        <Typography>در حال دریافت اطلاعات ...</Typography>
                                    </Box>
                                </>
                                )
                                : (
                                brands?.map((item: any) => (
                                <Brand
                                key={item["groupid"]}
                                title={item.title}
                                logo={item.logo}
                                showGiftCardHandler={() =>
                                showGiftCardHandler(item["groupid"])}
                                />
                                ))
                                )}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default GiftCardView;